import AbstractService from "../../vendors/services/abstractService";
import { publicApi } from "../shared/apis/api";

export default class SuporteService extends AbstractService {
  constructor() {
    super(publicApi, "suporte");
  }
}
